// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "../../../../../../../../node_modules/re-formality/src/Formality.mjs";
import * as Caml_format from "../../../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Caml_option from "../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Formality__ReactUpdate from "../../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.mjs";
import * as PartnerStore$PorterinFeature from "../store/PartnerStore.mjs";
import * as PartnersHelper$PorterinFeature from "../../../view/helpers/PartnersHelper.mjs";

var validators_infoSource = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      var infoSource = param.infoSource;
      if (infoSource !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: infoSource.value
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: PartnerStore$PorterinFeature.source_error_msg
              };
      }
    })
};

var validators_vehicle = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      var vehicle = param.vehicle;
      if (vehicle !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: {
                  id: Caml_format.int_of_string(vehicle.key),
                  name: vehicle.value
                }
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: PartnerStore$PorterinFeature.vehicle_error_msg
              };
      }
    })
};

var validators_city = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      var city = param.city;
      if (city !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: {
                  id: Caml_format.int_of_string(city.key),
                  name: city.value
                }
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: PartnerStore$PorterinFeature.city_error_msg
              };
      }
    })
};

var validators_mobile = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      var mobile = param.mobile;
      if (mobile === "") {
        return {
                TAG: /* Error */1,
                _0: PartnerStore$PorterinFeature.mobile_error_msg
              };
      } else {
        return PartnersHelper$PorterinFeature.validateMobileNumber(mobile);
      }
    })
};

var validators_name = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      return PartnersHelper$PorterinFeature.validateMaxLength(50, param.name, PartnerStore$PorterinFeature.name_error_msg);
    })
};

var validators = {
  infoSource: validators_infoSource,
  vehicle: validators_vehicle,
  city: validators_city,
  mobile: validators_mobile,
  name: validators_name
};

function initialFieldsStatuses(_input) {
  return {
          infoSource: /* Pristine */0,
          vehicle: /* Pristine */0,
          city: /* Pristine */0,
          mobile: /* Pristine */0,
          name: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: initialFieldsStatuses(input),
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.infoSource;
  var match_0 = match ? match._0 : Curry._1(validators.infoSource.validate, input);
  var match$1 = fieldsStatuses.vehicle;
  var match_0$1 = match$1 ? match$1._0 : Curry._1(validators.vehicle.validate, input);
  var match$2 = fieldsStatuses.city;
  var match_0$2 = match$2 ? match$2._0 : Curry._1(validators.city.validate, input);
  var match$3 = fieldsStatuses.mobile;
  var match_0$3 = match$3 ? match$3._0 : Curry._1(validators.mobile.validate, input);
  var match$4 = fieldsStatuses.name;
  var match_0$4 = match$4 ? match$4._0 : Curry._1(validators.name.validate, input);
  var infoSourceResult = match_0;
  var infoSourceResult$1;
  if (infoSourceResult.TAG === /* Ok */0) {
    var vehicleResult = match_0$1;
    if (vehicleResult.TAG === /* Ok */0) {
      var cityResult = match_0$2;
      if (cityResult.TAG === /* Ok */0) {
        var mobileResult = match_0$3;
        if (mobileResult.TAG === /* Ok */0) {
          var nameResult = match_0$4;
          if (nameResult.TAG === /* Ok */0) {
            return {
                    TAG: /* Valid */0,
                    output: {
                      name: nameResult._0,
                      mobile: mobileResult._0,
                      city: cityResult._0,
                      vehicle: vehicleResult._0,
                      infoSource: infoSourceResult._0
                    },
                    fieldsStatuses: {
                      infoSource: /* Dirty */{
                        _0: infoSourceResult,
                        _1: /* Shown */0
                      },
                      vehicle: /* Dirty */{
                        _0: vehicleResult,
                        _1: /* Shown */0
                      },
                      city: /* Dirty */{
                        _0: cityResult,
                        _1: /* Shown */0
                      },
                      mobile: /* Dirty */{
                        _0: mobileResult,
                        _1: /* Shown */0
                      },
                      name: /* Dirty */{
                        _0: nameResult,
                        _1: /* Shown */0
                      }
                    },
                    collectionsStatuses: undefined
                  };
          }
          infoSourceResult$1 = infoSourceResult;
        } else {
          infoSourceResult$1 = infoSourceResult;
        }
      } else {
        infoSourceResult$1 = infoSourceResult;
      }
    } else {
      infoSourceResult$1 = infoSourceResult;
    }
  } else {
    infoSourceResult$1 = infoSourceResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            infoSource: /* Dirty */{
              _0: infoSourceResult$1,
              _1: /* Shown */0
            },
            vehicle: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            city: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            },
            mobile: /* Dirty */{
              _0: match_0$3,
              _1: /* Shown */0
            },
            name: /* Dirty */{
              _0: match_0$4,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurInfoSourceField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.infoSource, validators_infoSource, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  infoSource: status,
                                  vehicle: init.vehicle,
                                  city: init.city,
                                  mobile: init.mobile,
                                  name: init.name
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurVehicleField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.vehicle, validators_vehicle, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  infoSource: init.infoSource,
                                  vehicle: status,
                                  city: init.city,
                                  mobile: init.mobile,
                                  name: init.name
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurCityField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.city, validators_city, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  infoSource: init.infoSource,
                                  vehicle: init.vehicle,
                                  city: status,
                                  mobile: init.mobile,
                                  name: init.name
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurMobileField */3 :
                  var result$3 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.mobile, validators_mobile, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  infoSource: init.infoSource,
                                  vehicle: init.vehicle,
                                  city: init.city,
                                  mobile: status,
                                  name: init.name
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurNameField */4 :
                  var result$4 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.name, validators_name, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  infoSource: init.infoSource,
                                  vehicle: init.vehicle,
                                  city: init.city,
                                  mobile: init.mobile,
                                  name: status
                                };
                        }));
                  if (result$4 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$4,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */5 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              Curry._2(onSubmit, output, {
                                    notifyOnSuccess: (function (input) {
                                        Curry._1(dispatch, {
                                              TAG: /* SetSubmittedStatus */5,
                                              _0: input
                                            });
                                      }),
                                    notifyOnFailure: (function (error) {
                                        Curry._1(dispatch, {
                                              TAG: /* SetSubmissionFailedStatus */6,
                                              _0: error
                                            });
                                      }),
                                    reset: (function (param) {
                                        Curry._1(dispatch, /* Reset */8);
                                      }),
                                    dismissSubmissionResult: (function (param) {
                                        Curry._1(dispatch, /* DismissSubmissionResult */7);
                                      })
                                  });
                            })
                        };
                  break;
              case /* DismissSubmissionError */6 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */7 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */8 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateInfoSourceField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.infoSource, state.submissionStatus, validators_infoSource, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            infoSource: status,
                                            vehicle: init.vehicle,
                                            city: init.city,
                                            mobile: init.mobile,
                                            name: init.name
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateVehicleField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.vehicle, state.submissionStatus, validators_vehicle, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            infoSource: init.infoSource,
                                            vehicle: status,
                                            city: init.city,
                                            mobile: init.mobile,
                                            name: init.name
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateCityField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, state.fieldsStatuses.city, state.submissionStatus, validators_city, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            infoSource: init.infoSource,
                                            vehicle: init.vehicle,
                                            city: status,
                                            mobile: init.mobile,
                                            name: init.name
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateMobileField */3 :
                  var nextInput$3 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$3, state.fieldsStatuses.mobile, state.submissionStatus, validators_mobile, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            infoSource: init.infoSource,
                                            vehicle: init.vehicle,
                                            city: init.city,
                                            mobile: status,
                                            name: init.name
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateNameField */4 :
                  var nextInput$4 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$4,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$4, state.fieldsStatuses.name, state.submissionStatus, validators_name, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            infoSource: init.infoSource,
                                            vehicle: init.vehicle,
                                            city: init.city,
                                            mobile: init.mobile,
                                            name: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */5 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: initialFieldsStatuses(input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: initialFieldsStatuses(state.input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */6 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */7 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateInfoSource: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateInfoSourceField */0,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateVehicle: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateVehicleField */1,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateCity: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateCityField */2,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateMobile: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateMobileField */3,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateName: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateNameField */4,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          blurInfoSource: (function (param) {
              Curry._1(dispatch, /* BlurInfoSourceField */0);
            }),
          blurVehicle: (function (param) {
              Curry._1(dispatch, /* BlurVehicleField */1);
            }),
          blurCity: (function (param) {
              Curry._1(dispatch, /* BlurCityField */2);
            }),
          blurMobile: (function (param) {
              Curry._1(dispatch, /* BlurMobileField */3);
            }),
          blurName: (function (param) {
              Curry._1(dispatch, /* BlurNameField */4);
            }),
          infoSourceResult: Formality.exposeFieldResult(state.fieldsStatuses.infoSource),
          vehicleResult: Formality.exposeFieldResult(state.fieldsStatuses.vehicle),
          cityResult: Formality.exposeFieldResult(state.fieldsStatuses.city),
          mobileResult: Formality.exposeFieldResult(state.fieldsStatuses.mobile),
          nameResult: Formality.exposeFieldResult(state.fieldsStatuses.name),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.infoSource || match.vehicle || match.city || match.mobile || match.name) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              Curry._1(dispatch, /* Submit */5);
            }),
          dismissSubmissionError: (function (param) {
              Curry._1(dispatch, /* DismissSubmissionError */6);
            }),
          dismissSubmissionResult: (function (param) {
              Curry._1(dispatch, /* DismissSubmissionResult */7);
            }),
          mapSubmissionError: (function (map) {
              Curry._1(dispatch, {
                    TAG: /* MapSubmissionError */7,
                    _0: map
                  });
            }),
          reset: (function (param) {
              Curry._1(dispatch, /* Reset */8);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

export {
  Form ,
}
/* react Not a pure module */
